/* eslint-disable no-underscore-dangle */
import React, {
  memo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

const defaultRecord = () => ({
  year: 2000,
  area_total: '0',
});

function RHistoryTablePart({
  data, options, onChange, readOnly, errors, currentOrg,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });

  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />
      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.year.label}
              </TableCell>
              <TableCell>
                {fields.area_total.label}
              </TableCell>
              <TableCell>
                {fields.area_live.label}
              </TableCell>
              <TableCell>
                {fields.area_hot.label}
              </TableCell>
              <TableCell>
                {fields.area_summer.label}
              </TableCell>
              <TableCell>
                {fields.amount_room.label}
              </TableCell>
              <TableCell>
                {fields.account_electro.label}
              </TableCell>
              <TableCell>
                {fields.account_gas.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row, index) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
                errors={errors.length <= index ? null : errors[index]}
                currentOrg={currentOrg}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

RHistoryTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.shape({

  })),
  currentOrg: PropTypes.number,
};

RHistoryTablePart.defaultProps = {
  readOnly: false,
  errors: [],
  currentOrg: null,
};

export default memo(RHistoryTablePart);
